// extracted by mini-css-extract-plugin
module.exports = {"btn":"_2ssv2C1pjET0tO8lgxpqr1","icon":"_3FGJYYE1o7TI98FFsoR2lS"};